
export default {
    name: "Quotation",
    meta: {
        icon: "directions_boat",
        expanded: true,
        auth: true,
    },
    departmentName: "Common",
    finalPagePermision: "",
    children: [
        {
            name: "Quotation Library",
            path: "/allQuotationLib",
            permissionName: 'Quotation_Library',
            keywords: ['Quotation Library', 'Quotation_Library'],
            meta: {
                icon: "directions_boat",
                auth: true,
            },
            component: require("../component/allModuleForm/viewAllQoutation.vue"),
            finalPagePermision: "Quotation_Library",
        },

        {
            name: "Quotation Search",
            path: "/allQuotationSearch",
            permissionName: '',
            keywords: ['Quotation Library', 'Quotation_Library','Quotation Search'],
            meta: {
                icon: "directions_boat",
                auth: true,
            },
            component: require("../component/allModuleForm/viewAllQoutationSearch.vue"),
            finalPagePermision: "",
        },


    ],
};


// WEBPACK FOOTER //
// ./src/sidebar/common.js